module.exports = __webpack_public_path__ + "img/basic_skinwash_tube_202306.57e850c2.jpg";